import React from 'react';
import {useDispatch} from 'react-redux';

import {searchAccounts} from '../reducers/recordsSlice';

import HeadingRow from 'features/credentials/components/HeadingRow';

import {useNavigate} from 'react-router-dom';
import EmailForm from '../forms/EmailForm';
import {Formik} from 'formik';

export const AddPage = () => {
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const handleSubmit = (values) => {
        dispatch(searchAccounts(values.email));

        const timer = setTimeout(() => {
            navigate('/accounts');
            return false;
        }, 1000);
        return () => clearTimeout(timer);
    };

    const handleReset = (values, formikBag) => {
        formikBag.resetForm();
        return false;
    };

    let initialValues = { email: '' };

    return (
        <React.Fragment>
            <HeadingRow title="Add an account:" subtitle="" />
            <Formik>
                <EmailForm
                    handleSubmit={handleSubmit}
                    handleReset={handleReset}
                    record={initialValues}
                />
            </Formik>
        </React.Fragment>
    );
};
